export enum UserMode {
    CustomerEmployee,
    Employee,
    MeetingRoomApp
}
